import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "elevation-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_rectangle = _resolveComponent("l-rectangle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_shared_map = _resolveComponent("shared-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_shared_map, {
      "drawing-tool-cursor": _ctx.drawingToolCursor,
      onLMapReady: _ctx.setLMap,
      onMousedown: _ctx.handleMouseDown,
      onMouseup: _ctx.handleMouseUp,
      onMousemove: _ctx.handleMapMouseMove
    }, {
      map: _withCtx(() => [
        (_ctx.gridStore.leafletBbox)
          ? (_openBlock(), _createBlock(_component_l_rectangle, {
              key: 0,
              "data-testid": "grid-map-bbox",
              "fill-color": _ctx.color,
              "fill-opacity": 0.35,
              color: _ctx.color,
              stroke: false,
              bounds: _ctx.gridStore.leafletBbox,
              interactive: false
            }, null, 8, ["fill-color", "color", "bounds"]))
          : _createCommentVNode("", true),
        (_ctx.outerBounds)
          ? (_openBlock(), _createBlock(_component_l_rectangle, {
              key: 1,
              "data-testid": "grid-map-bbox-selected",
              fill: false,
              color: _ctx.color,
              weight: 3,
              bounds: _ctx.outerBounds,
              interactive: false
            }, null, 8, ["color", "bounds"]))
          : _createCommentVNode("", true)
      ]),
      tools: _withCtx(() => [
        _createVNode(_component_v_tooltip, {
          text: _ctx.t('raster.tooltip.reset_bbox'),
          bottom: "",
          "open-delay": 200
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
              class: 'ml-4 delete-button zamg-button-outline-primary',
              "data-testid": "map-bbox-delete",
              variant: "outlined",
              elevation: "2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gridStore.resetBbox()))
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "primary" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" mdi-delete-outline ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 8, ["text"]),
        _createVNode(_component_v_tooltip, {
          text: _ctx.t('raster.tooltip.select_bbox_on_map'),
          bottom: "",
          "open-delay": 200
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
              class: ["ml-4 zamg-button-outline-primary", [_ctx.toolIsActive ? 'active-button' : '']],
              "min-width": "30px",
              width: "30px",
              height: "32px",
              "data-testid": "grid-map-marker",
              onClick: _ctx.toggleToolIsActive
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "custom:zamgRectangle",
                  color: "primary"
                })
              ]),
              _: 1
            }, 16, ["class", "onClick"])
          ]),
          _: 1
        }, 8, ["text"])
      ]),
      _: 1
    }, 8, ["drawing-tool-cursor", "onLMapReady", "onMousedown", "onMouseup", "onMousemove"])
  ]))
}